import { useMutation } from "@tanstack/react-query"
import { postOnboardingInfoAPI } from "../lib/api/api"


export let useUpdateFilterMutation = (data) => useMutation({
    mutationFn: async (data) => {
        await postOnboardingInfoAPI(data)
    },
})